import dhofarLogo from '../assets/img/DhofarDarkLogo.png';

export default function Loading(props) {
  const { message } = props;
  return (
    <>
      <div className='absolute top-0 right-0 z-50 flex h-full w-full items-center justify-center '>
        <div className='text-center'>
          {/* The source asset is ~2000px wide, so it is constrained here -
              the old mark was a small SVG and carried its own intrinsic size. */}
          <img
            className='animate-bounce inline-block w-32 max-w-full'
            src={dhofarLogo}
            alt='loading'
          />
          <small className='block text-sm text-gray-400 animate-pulse'>
            {message ? message : 'Loading'}
          </small>
        </div>
      </div>
    </>
  );
}
